var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import { traitClass } from "../Trait";
import mixTraits from "../mixTraits";
import CatalogMemberTraits from "./CatalogMemberTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import MappableTraits from "./MappableTraits";
import UrlTraits from "./UrlTraits";
let MapboxVectorTileCatalogItemTraits = (_dec = traitClass({
  description: "Creates one catalog item from url that points to a mvt service.",
  example: {
    type: "mvt",
    name: "mvt example",
    description: "Federal electoral boundaries which will apply at the 2019 federal election. Produced by combining boundary datasets provided by AEC for each state.",
    url: "https://tiles.terria.io/ELB_2019/{z}/{x}/{y}.pbf",
    opacity: 1,
    lineColor: "hsl(180,80%,30%)",
    layer: "ELB_2019",
    maximumNativeZoom: 12,
    minimumZoom: 0,
    id: "some unique id"
  }
}), _dec2 = primitiveTrait({
  type: "string",
  name: "lineColor",
  description: "This property exists for backward compatibility. The outline color of the features, specified as a CSS color string. This will only be used if `layer` trait has been set. For more complex styling - see `style` trait."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "fillColor",
  description: "This property exists for backward compatibility. The fill color of the features, specified as a CSS color string. This will only be used if `layer` trait has been set. For more complex styling - see `style` trait."
}), _dec4 = primitiveTrait({
  type: "string",
  name: "layer",
  description: "This property exists for backward compatibility. It can be used to only show a particular layer in the tileset."
}), _dec5 = anyTrait({
  name: "style",
  description: "JSON style spec for MVT. This supports subset of Mapbox style spec (https://docs.mapbox.com/mapbox-gl-js/style-spec/layers/).\n\nFor supported properties - refer to https://github.com/protomaps/protomaps.js/blob/master/src/compat/json_style.ts.\n\nFor example:\n```json\n{\n  \"layers\": [\n    {\n      \"type\": \"fill\",\n      \"source-layer\": \"buildings\",\n      \"paint\": {\n        \"fill-color\": \"black\"\n      }\n    },\n    {\n      \"type\": \"line\",\n      \"source-layer\": \"buildings\",\n      \"paint\": {\n        \"line-color\": \"red\",\n        \"line-width\": 1\n      }\n    },\n    {\n      \"type\": \"symbol\",\n      \"source-layer\": \"places\",\n      \"layout\": {\n        \"text-size\": 20,\n        \"text-font\": \"sans-serif\"\n      },\n      \"paint\": {\n        \"text-color\": \"red\"\n      }\n    }\n  ]\n}\n```"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Style URL",
  description: "URL to JSON file for styling. See `style` trait for more info."
}), _dec7 = primitiveTrait({
  type: "string",
  name: "idProperty",
  description: "The name of the property that is a unique ID for features."
}), _dec8 = primitiveTrait({
  type: "string",
  name: "nameProperty",
  description: "The name of the property from which to obtain the name of features."
}), _dec9 = primitiveTrait({
  type: "number",
  name: "maximumNativeZoom",
  description: "The maximum zoom level for which tile files exist."
}), _dec0 = primitiveTrait({
  type: "number",
  name: "maximumZoom",
  description: "The maximum zoom level that can be displayed by using the data in the  MapboxVectorTileCatalogItem#maximumNativeZoom tiles."
}), _dec1 = primitiveTrait({
  type: "number",
  name: "minimumZoom",
  description: "The minimum zoom level for which tile files exist."
}), _dec(_class = (_class2 = class MapboxVectorTileCatalogItemTraits extends mixTraits(LayerOrderingTraits, UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits, ImageryProviderTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "lineColor", _descriptor, this);
    _initializerDefineProperty(this, "fillColor", _descriptor2, this);
    _initializerDefineProperty(this, "layer", _descriptor3, this);
    _initializerDefineProperty(this, "style", _descriptor4, this);
    _initializerDefineProperty(this, "styleUrl", _descriptor5, this);
    _initializerDefineProperty(this, "idProperty", _descriptor6, this);
    _initializerDefineProperty(this, "nameProperty", _descriptor7, this);
    _initializerDefineProperty(this, "maximumNativeZoom", _descriptor8, this);
    _initializerDefineProperty(this, "maximumZoom", _descriptor9, this);
    _initializerDefineProperty(this, "minimumZoom", _descriptor0, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "lineColor", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "fillColor", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "layer", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "style", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "styleUrl", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "idProperty", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "FID";
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "nameProperty", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "maximumNativeZoom", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 12;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "maximumZoom", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 28;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "minimumZoom", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _class2)) || _class);
export { MapboxVectorTileCatalogItemTraits as default };